import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Refund from "./pages/Refund";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import About from "./pages/About";
import ReturnPolicy from "./pages/ReturnPolicy";
import Faq from "./pages/Faq";
import LabTest from "./Diagnostic/LabTest";
import Filter from "./layout/Filter";
import Package from "./Diagnostic/Package";
import PackageDetail from "./Diagnostic/PackageDetail";
import BookingForm from "./Diagnostic/BookingForm";
import CheckOut from "./Diagnostic/CheckOut";
import AllPartners from "./Diagnostic/AllPartners";
import DrBLal from "./Diagnostic/DrBLal";
import DrLalPath from "./Diagnostic/DrLalPath";
import IcuHome from "./IcuPages/IcuHome";
import IcuHospital from "./IcuPages/IcuHospital";
import NursingCare from "./caregiver/nursingcare/NursingCare";
import Stepper from "./IcuPages/Stepper";
import IcuForm from "./IcuPages/IcuForm";
import IcuInstallationEnquiry from "./IcuPages/IcuInstallationEnquiry";
import IcuCheckout from "./IcuPages/IcuCheckout";
import ThankYou from "./IcuPages/ThankYou";
import ScrollToTop from "./components/ScrollToTop";
import CarePlan from "./caregiver/nursingcare/CarePlan";
import NursingBooking from "./caregiver/nursingcare/NursingBooking";
import NursingAssesment from "./caregiver/nursingcare/NursingAssesment";
import NursingLongBooking from "./caregiver/nursingcare/NursingLongBooking";
import LongtermCheckout from "./caregiver/nursingcare/LongtermCheckout";
import Physiotherapy from "./caregiver/physiotherapy/Physiotherapy";
import BedsideAttendant from "./caregiver/bedsideattendant/BedsideAttendant";
import Doctorconsult from "./doctorconsultation/Doctorconsult";
import DoctorList from "./doctorconsultation/DoctorList";
import DoctorDetail from "./doctorconsultation/DoctorDetail";
import MedicalEquipments from "./medicalequipments/MedicalEquipments";
import Medicine from "./medicalequipments/Medicine";

import EquipmentsBooking from "./medicalequipments/EquipmentsBooking";
import Addcart from "./components/Addcart";
import EquipmentCart from "./medicalequipments/EquipmentCart";
import MedicineDetail from "./medicalequipments/MedicineDetail";
import MedicineCheckout from "./medicalequipments/MedicineCheckout";
import ScrollFix from "./components/ScrollFix";
import NeedHelp from "./components/NeedHelp";
import Registration from "./pages/Registration";

// User_Dashboard
import Dashboard from "./UserDashboard/Pages/Dashboard";
import ManageProfile from "./UserDashboard/Pages/ManageProfile";
import MyOrders from "./UserDashboard/Pages/MyOrders";
import PurchaseHistory from "./UserDashboard/Pages/PurchaseHistory";
import Support from "./UserDashboard/Pages/Support";
import AddressBook from "./UserDashboard/Pages/AddressBook";
import MyorderDetail from "./UserDashboard/Pages/MyorderDetail";
import "./Responsive.css";

function App() {
  return (
    <Router>
      <ScrollFix />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-condition" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-cancellation-policy" element={<Refund />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/labtest" element={<LabTest />} />
        <Route path="/filter" element={<Filter />} />
        <Route path="/package" element={<Package />} />
        <Route path="/packagedetail" element={<PackageDetail />} />
        <Route path="/bookingform" element={<BookingForm />} />
        <Route path="/checkout" element={<CheckOut />} />
        <Route path="/allpartners" element={<AllPartners />} />
        <Route path="/drblal" element={<DrBLal />} />
        <Route path="/drlalapath" element={<DrLalPath />} />
        <Route path="/icu-installation-at-home" element={<IcuHome />} />
        <Route path="/icu-installation-at-hospital" element={<IcuHospital />} />
        <Route path="/home-nursingcare" element={<NursingCare />} />
        <Route path="/icu-home-assesment" element={<Stepper />} />
        <Route path="/icu-home-booking" element={<IcuForm />} />
        <Route
          path="/icu-installation-enquiry"
          element={<IcuInstallationEnquiry />}
        />
        <Route path="/icucheckout" element={<IcuCheckout />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/careplan" element={<CarePlan />} />
        <Route path="/service-booking" element={<NursingBooking />} />
        <Route path="/nursingassesment" element={<NursingAssesment />} />
        <Route path="/nursinglongbooking" element={<NursingLongBooking />} />
        <Route path="/longtermcheckout" element={<LongtermCheckout />} />
        <Route path="/home-physiotherapy" element={<Physiotherapy />} />
        <Route path="/home-bedsideattendant" element={<BedsideAttendant />} />
        <Route path="/doctorconsult" element={<Doctorconsult />} />
        <Route path="/doctor-consultation-services" element={<DoctorList />} />
        <Route path="/doctordetail" element={<DoctorDetail />} />
        <Route path="/doctordetail/:slug" element={<DoctorDetail />} />
        <Route path="/product-on-rent" element={<MedicalEquipments />} />
        <Route path="/equipmentsbooking" element={<EquipmentsBooking />} />
        <Route path="/service-cart" element={<Addcart />} />
        <Route path="/cart" element={<EquipmentCart />} />
        <Route path="/product" element={<MedicineDetail />} />
        <Route path="/product/:id" element={<MedicineDetail />} />
        <Route path="/medicine" element={<Medicine />} />
        <Route path="/medicinecheckout" element={<MedicineCheckout />} />
        <Route path="/needhelp" element={<NeedHelp />} />
        <Route path="/registration" element={<Registration />} />

        {/*  User_Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/manageprofile" element={<ManageProfile />} />
        <Route path="/myorders" element={<MyOrders />} />
        <Route path="/purchasehistory" element={<PurchaseHistory />} />
        <Route path="/support" element={<Support />} />
        <Route path="/addressbook" element={<AddressBook />} />
        <Route path="/myorderDetail" element={<MyorderDetail />} />
      </Routes>
    </Router>
  );
}

export default App;
